import 'core-js/modules/es.object.assign.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material/styles';
import { spacing } from '@mui/system';
import '@mui/material';
import { useUtility } from '../../hooks/use-utility.js';

let _ = t => t,
  _t;
const Content = styled('svg')(_t || (_t = _`
  ${0};
`), spacing);
const Logo = props => {
  const {
    palette
  } = useUtility();
  const Size = {
    large: {
      width: '132px',
      height: '30px'
    },
    medium: {
      width: '96px',
      height: '22px'
    },
    small: {
      width: '64px',
      height: '15px'
    }
  };
  const fill = props.hierarchy === 'primary' ? palette('onSurface') : palette('onSurfaceVariant');
  const width = Size[props.size].width;
  const height = Size[props.size].height;
  return jsxs(Content, Object.assign({}, props, {
    width: width,
    height: height,
    viewBox: `0 0 132 30`,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("path", {
      d: "M74.1304 14.1759C76.1527 12.7038 77.186 10.7273 77.186 8.16177C77.186 5.84796 76.3239 3.91173 74.6006 2.35509C72.9197 0.799463 70.8077 0 68.3513 0H56.3712V29.4523H78.3492V14.1759H74.1304ZM73.3941 24.9082H61.3274V4.54405H68.3513C70.5488 4.54405 72.2298 6.22755 72.2298 8.4145C72.2298 10.6014 70.5488 12.2849 68.3513 12.2849H66.2826V16.6608H73.393V24.9082H73.3941Z",
      fill: fill
    }), jsx("path", {
      d: "M17.8839 0H22.8401V29.4523H17.8839V16.7041H4.95619V29.4533H0V0H4.95619V12.0755H17.8839V0Z",
      fill: fill
    }), jsx("path", {
      d: "M28.2521 0H33.2083V19.3965C33.2083 22.973 35.3626 25.2868 39.6722 25.2868C43.9818 25.2868 46.1361 22.973 46.1361 19.3965V0H51.0923V19.6916C51.0923 22.8471 50.0146 25.3301 47.9036 27.223C45.7916 29.0747 43.0341 30 39.6722 30C36.3113 30 33.5528 29.0747 31.4418 27.223C29.3298 25.3301 28.2532 22.8471 28.2532 19.6916V0H28.2521Z",
      fill: fill
    }), jsx("path", {
      d: "M88.5854 24.8246H100.868V29.4533H83.6292V0H88.5854V24.8246Z",
      fill: fill
    }), jsx("path", {
      d: "M126.656 29.4523L124.544 23.5197H111.702L109.59 29.4523H104.204L115.15 0H121.098L132 29.4523H126.656ZM113.341 18.9757H122.907L118.125 5.67981L113.341 18.9757Z",
      fill: fill
    })]
  }));
};

export { Logo };
